import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconModule } from '@y42/core/icon';
import { DataTestStatusCellRendererComponent } from './data-test-status-cell-renderer.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, MatTooltipModule, IconModule],
  declarations: [DataTestStatusCellRendererComponent],
  exports: [DataTestStatusCellRendererComponent],
})
export class DataTestStatusCellRendererModule {}
